import { UpdateSchoolProfileDocument } from "@pathwright/graphql-client/src/generated"

export default UpdateSchoolProfileDocument
